<template>
    <div class="footer" style="">
        <div style="display: flex; align-items: flex-start; flex-direction: column">
            <div class="company-text" style="margin-top: 10px;">
                Supported by
            </div>

            <img style="width: 200px; margin-top: 10px" src="@/assets/msins-logo-white.png" alt="MSINS"/>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped lang="scss">
    @import "@/styles/variables.scss";

    .footer {
        color: $app-blue-text;
        padding: 10px 50px 20px 50px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .mobile .footer {
        justify-content: center;
    }

    .icon-btn {
        margin: 0 !important;
    }

    .company-text {
        font-size: 10pt;
        font-weight: 500;
    }


    .mobile .company-text {
        align-self: center;
    }
</style>
